import React, { useState, useContext } from "react";
import Select from "react-select";
import { CustomerContext } from "../../context/CustomerContext";
import { BranchesContext } from "../../context/BranchesContext";

const CustomerBranch = ({ customer, handleCallback }) => {
  const [loading, setLoading] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(customer.branch);

  const { postCustomer } = useContext(CustomerContext);
  const { branches, editBranchMode, setEditBranchMode } = useContext(BranchesContext);

  const branchOptions = branches.map((branch) => ({
    value: branch.branch_id,
    label: (
      <span
        style={{
          backgroundColor: branch.primary_color,
          color: "#fff",
          padding: "2px 8px",
          borderRadius: "10px",
        }}
      >
        {branch.name}
      </span>
    ),
    branch,
  }));

  const saveCallback = () => {
    handleCallback();
    setLoading(false);
    setEditBranchMode(false);
  }

  const handleBranchChange = (option) => {
    setSelectedBranch(option.branch);
  };

  const handleSaveBranch = async () => {
    setLoading(true);
    postCustomer({ ...customer, branch_id: selectedBranch?.branch_id }, saveCallback);
  };

  return (
    <div className="row mb-3 align-items-center">
      <div className="col-6">Franquicia</div>
      <div className="col-6 d-flex align-items-center">
        {!editBranchMode ? (
          <>
            <span
              className="badge badge-pill"
              style={{
                backgroundColor: customer.branch.primary_color,
              }}
            >
              {customer.branch.name}
            </span>
            <button
              className="btn btn-outline-secondary btn-sm ms-2"
              onClick={() => setEditBranchMode(true)}
              title="Editar franquicia"
            >
              <i className="fa fa-edit" />
            </button>
          </>
        ) : (
          <>
            <Select
              className="me-2"
              options={branchOptions}
              defaultValue={branchOptions.find(
                (opt) => opt.value === selectedBranch.id
              )}
              onChange={handleBranchChange}
              isSearchable
              menuPlacement="auto"
              styles={{
                control: (base) => ({
                  ...base,
                  minWidth: 150,
                }),
              }}
            />
            <button
              className="btn btn-primary btn-sm me-1"
              onClick={handleSaveBranch}
              disabled={loading}
              title="Guardar"
            >
              <i className="fa fa-check" />
            </button>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => {
                setEditBranchMode(false);
                setSelectedBranch(customer.branch);
              }}
              disabled={loading}
              title="Cancelar"
            >
              <i className="fa fa-times" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CustomerBranch;
